<template>
  <div class="langVoiceParameters">

    <div class="field is-horizontal locale">
      <div class="field-label is-normal"><label class="label">Locale</label></div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <input class="input" type="text" placeholder="Locale" :value="locale"  @input="$emit('update:locale', $event.target.value)"/>
          </div>
        </div>
      </div>
    </div>
    <div class="field is-horizontal vendor">
      <div class="field-label is-normal"><label class="label">Generation vendor</label></div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <div class="select">
              <select :value="vendor" @input="$emit('update:vendor', $event.target.value)">
                <option value="yandex">Yandex</option>
                <option value="google">Google</option>
                <option value="azure">Azure</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="field is-horizontal voice">
      <div class="field-label is-normal"><label class="label">Voice</label></div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <input class="input" type="text" placeholder="Voice Name" :value="voiceName"  @input="$emit('update:voiceName', $event.target.value)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'LocalVoice',
      props: ['locale', 'vendor', 'voiceName'],
      data() {
        return {
          parameters: {
            commonParameters: {
              locale: ''
            },
            voiceParameters: {
              vendor: '',
              voiceName: ''
            }
          },
          voices: {
            'Yandex': [
              {
                value: 'jane'
              },
              {
                value: 'oksana'
              },
              {
                value: 'alyss '
              },
              {
                value: 'omazh'
              },
              {
                value: 'zahar '
              },
              {
                value: 'ermil '
              }
            ],
            'Google': [],
            'Azure': []
          }
        }
      }
    }
</script>

<style scoped>
  .langVoiceParameters {
    display: flex;
  }

  .langVoiceParameters .locale input {
    max-width: 64px;
  }

  .langVoiceParameters .vendor, .langVoiceParameters .voice {
    margin-left:40px
  }

  .langVoiceParameters .is-horizontal {
    display:flex;
  }

  .is-horizontal .field-label , .is-horizontal .field-body{
    display: inline-block;
  }

  .field-label {
    margin-top: 6px;
    margin-right: 2px;
  }
</style>



// WEBPACK FOOTER //
// LocalVoice.vue?6d177b6c